import React from 'react';
import { Button } from 'antd';

export const PrimaryButton = ({ icon, text, onClick, className = "", danger = false, ...props }) => {
  return (
    <Button
      type="primary"
      danger={danger}
      icon={icon}
      onClick={onClick}
      className={`pcu-radius-8 pcu-font-700 pcu-h-34px pcu-padding-x-20 ${!danger ? 'pcu-gradient-btn pcu-border-none pcu-shadow-sm' : ''} ${className}`}
      {...props}
    >
      {text}
    </Button>
  );
};

export const ResetButton = ({ icon, text = "Reset", onClick, className = "", ...props }) => {
  return (
    <Button
      className={`product-setup-reset-btn pcu-radius-8 pcu-font-700 pcu-h-34px ${className}`}
      icon={icon}
      onClick={onClick}
      {...props}
    >
      {text}
    </Button>
  );
};

export const OutlineButton = ({ icon, text, onClick, className = "", danger = false, ...props }) => {
    return (
        <Button 
            size="middle" 
            danger={danger}
            icon={icon}
            onClick={onClick}
            className={`product-setup-cancel-btn pcu-radius-8 pcu-font-600 pcu-h-34px ${className}`}
            {...props}
        >
            {text}
        </Button>
    )
}
